var Handlebars = require("/home/travis/build/thelounge/lounge/node_modules/handlebars/runtime.js");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {});

  return "<div class=\"toggle-content toggle-type-"
    + container.escapeExpression(container.lambda((depth0 != null ? depth0.type : depth0), depth0))
    + ((stack1 = helpers["if"].call(alias1,(depth0 != null ? depth0.shown : depth0),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = __default(require("/home/travis/build/thelounge/lounge/client/js/libs/handlebars/equal.js")).call(alias1,(depth0 != null ? depth0.type : depth0),"image",{"name":"equal","hash":{},"fn":container.program(4, data, 0),"inverse":container.program(6, data, 0),"data":data})) != null ? stack1 : "")
    + "</div>\n";
},"2":function(container,depth0,helpers,partials,data) {
    return " show";
},"4":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "		<a class=\"toggle-thumbnail\" href=\""
    + alias2(alias1((depth0 != null ? depth0.link : depth0), depth0))
    + "\" target=\"_blank\" rel=\"noopener\">\n			<img src=\""
    + alias2(alias1((depth0 != null ? depth0.thumb : depth0), depth0))
    + "\">\n		</a>\n";
},"6":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? depth0.thumb : depth0),{"name":"if","hash":{},"fn":container.program(7, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "		<a class=\"toggle-text\" href=\""
    + alias2(alias1((depth0 != null ? depth0.link : depth0), depth0))
    + "\" target=\"_blank\" rel=\"noopener\">\n			<div class=\"head\" title=\""
    + alias2(alias1((depth0 != null ? depth0.head : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? depth0.head : depth0), depth0))
    + "</div>\n			<div class=\"body\" title=\""
    + alias2(alias1((depth0 != null ? depth0.body : depth0), depth0))
    + "\">"
    + alias2(alias1((depth0 != null ? depth0.body : depth0), depth0))
    + "</div>\n		</a>\n";
},"7":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression;

  return "			<a class=\"toggle-thumbnail\" href=\""
    + alias2(alias1((depth0 != null ? depth0.link : depth0), depth0))
    + "\" target=\"_blank\" rel=\"noopener\">\n				<img src=\""
    + alias2(alias1((depth0 != null ? depth0.thumb : depth0), depth0))
    + "\" class=\"thumb\">\n			</a>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.blockHelperMissing.call(depth0,container.lambda((depth0 != null ? depth0.preview : depth0), depth0),{"name":"preview","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "");
},"useData":true});


//////////////////
// WEBPACK FOOTER
// ./client/views/msg_preview.tpl
// module id = 238
// module chunks = 0